/* Unified Route Configuration Mapped to the numeric IDs found in the production XML: 
   - line10 (Base): 114
   - line10a (Sat): 117
   - line20 (Base): 115
   - line20a (Tue): 118
*/
export const timetables = [
  {
    id: 'line10',
    socketId: 114,
    title: 'Line 10',
    descriptionKey: 'line10Desc',
    color: 'from-blue-600 to-blue-800',
    icon: 'FaBus',
    variants: {
      6: { id: 'line10a', socketId: 117, title: 'Line 10a', noteKey: 'saturdayNote' } // Saturday
    }
  },
  {
    id: 'line20',
    socketId: 115,
    title: 'Line 20',
    descriptionKey: 'line20Desc',
    color: 'from-emerald-600 to-teal-800',
    icon: 'FaBus',
    variants: {
      2: { id: 'line20a', socketId: 118, title: 'Line 20a', noteKey: 'tuesdayNote' } // Tuesday
    }
  }
];